<div class="view-changes-container">
  <!-- Filters and Search Bar -->
  <div class="repo-filters">
    <div class="filters-group">
      <p-floatlabel  variant="on" *ngIf="suiteMode">
        <p-multiSelect
          inputId="application-name"
          styleClass="application-name-filter"
          [options]="applicationNameOptions"
          [(ngModel)]="filterApplicationIds"
          (ngModelChange)="onFilterChange()"
          [showClear]="true"
          [resetFilterOnHide]="true"
          appendTo="body"
          [overlayOptions]="{ baseZIndex: 10002 }"
        >
          <ng-template pTemplate="selectedItems" let-items>
            @if (items?.length > 0) {
              <span class="selected-item-text">{{ appNameMap[items[0]] }}</span>
              @if (items.length > 1) {
                <span class="selected-count">+{{ items.length - 1 }}</span>
              }
            }
          </ng-template>
        </p-multiSelect>
        <label for="application-name">{{ 'APPLICATION_NAME' | translate }}</label>
      </p-floatlabel>
      <p-floatlabel variant="on">
        <p-multiSelect
          inputId="component-type"
          styleClass="component-type-filter"
          [options]="componentTypeOptions"
          [(ngModel)]="filterComponentTypes"
          (ngModelChange)="onFilterChange()"
          [showClear]="true"
          [resetFilterOnHide]="true"
          appendTo="body"
          [overlayOptions]="{ baseZIndex: 10002 }"
        >
          <ng-template pTemplate="selectedItems" let-items>
            @if (items?.length > 0) {
              <span class="selected-item-text">{{ getFilterLabel('componentType', items[0]) }}</span>
              @if (items.length > 1) {
                <span class="selected-count">+{{ items.length - 1 }}</span>
              }
            }
          </ng-template>
        </p-multiSelect>
        <label for="component-type">{{ 'COMPONENT_TYPE' | translate }}</label>
      </p-floatlabel>

      <p-floatlabel variant="on">
        <p-datepicker
          inputId="start-date"
          [(ngModel)]="startDate"
          (onClose)="onDateFilterChange()"
          (onClear)="onDateFilterChange()"
          [dateFormat]="dateFormat"
          [showTime]="true"
          [hourFormat]="hourFormat"
          [stepHour]="1"
          [stepMinute]="1"
          [showClear]="!!startDate"
          appendTo="body"
          [showIcon]="true"
          iconDisplay="input"
          [maxDate]="endDate"
        ></p-datepicker>
        <label for="start-date">{{ 'FROM_DATE' | translate }}</label>
      </p-floatlabel>

      <p-floatlabel variant="on">
        <p-datepicker
          inputId="end-date"
          [(ngModel)]="endDate"
          (onClose)="onDateFilterChange()"
          (onClear)="onDateFilterChange()"
          [dateFormat]="dateFormat"
          [showTime]="true"
          [hourFormat]="hourFormat"
          [stepHour]="1"
          [stepMinute]="1"
          [showClear]="!!endDate"
          appendTo="body"
          [showIcon]="true"
          iconDisplay="input"
          [minDate]="startDate"
        ></p-datepicker>
        <label for="end-date">{{ 'TO_DATE' | translate }}</label>
      </p-floatlabel>
            <button
              *ngIf="hasActiveFilters"
              pButton
              type="button"
              [label]="'CLEAR_FILTERS' | translate"
              class="p-button-outlined p-button-sm clear-all-btn"
              (click)="clearFilters()"
            ></button>
    </div>
  </div>

  <!-- Component Changes Table -->
  <div class="table-scroll-container" #tableContainer>
    <p-table [value]="componentChanges" [scrollable]="true" scrollHeight="flex" styleClass="repo-table">
      <ng-template pTemplate="header">
        <tr>
          <th *ngIf="suiteMode" scope="col">
            {{ 'APPLICATION_NAME' | translate }}
          </th>
          <th scope="col">
            {{ 'COMPONENT_TYPE' | translate }}
            <span *ngIf="sortField === 'componentType'">
            </span>
          </th>
          <th scope="col">
            {{ 'COMPONENT_NAME' | translate }}
          </th>
          <th scope="col">
            {{ 'UPDATED' | translate }}
          </th>
          <th scope="col">
            {{ 'CREATED' | translate }}
          </th>
          <th scope="col">
            {{ 'DELETED' | translate }}
          </th>
          <th scope="col">
            {{ 'RENAMED' | translate }}
          </th>
          <th scope="col"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-change>
        <tr>
          <td *ngIf="suiteMode" pTooltip="{{ change.applicationName || change.appId }}" tooltipPosition="top">{{ change.applicationName || change.appId }}</td>
          <td pTooltip="{{ utilService.formatComponentType(change.componentType) }}" tooltipPosition="top">{{ utilService.formatComponentType(change.componentType) }}</td>
          <td pTooltip="{{ change.componentDisplayName }}" tooltipPosition="top">{{ change.componentDisplayName }}</td>
          <td>
            <ng-container *ngIf="change.updated?.author; else noUpdated">
              <div class="author-cell">
                <p-avatar
                  [label]="change.updated.author[0].toUpperCase()"
                  shape="circle"
                  [style]="{ 'background-color': getBgColor(change.updated.author) }"
                  size="small"
                  styleClass="author-avatar"
                ></p-avatar>
                <div class="author-info" pTooltip="{{ change.updated.author + '&#10;' + (change.updated.timestamp | date: defaultDateTimeDisplayFormat) }}" tooltipPosition="top" [escape]="false">
                  <span class="author-name">{{ change.updated.author }}</span>
                  <span class="author-date">{{ change.updated.timestamp | date: defaultDateTimeDisplayFormat }}</span>
                </div>
              </div>
            </ng-container>
            <ng-template #noUpdated><span class="empty-cell"></span></ng-template>
          </td>
          <td>
            <ng-container *ngIf="change.created?.author; else noCreated">
              <div class="author-cell"> 
                <p-avatar
                  [label]="change.created.author[0].toUpperCase()"
                  shape="circle"
                  [style]="{ 'background-color': getBgColor(change.created.author) }"
                  size="small"
                  styleClass="author-avatar"
                ></p-avatar>
                <div class="author-info" pTooltip="{{ change.created.author + '&#10;' + (change.created.timestamp | date: defaultDateTimeDisplayFormat) }}" tooltipPosition="top" [escape]="false">
                  <span class="author-name">{{ change.created.author }}</span>
                  <span class="author-date">{{ change.created.timestamp | date: defaultDateTimeDisplayFormat }}</span>
                </div>
              </div>
            </ng-container>
            <ng-template #noCreated><span class="empty-cell"></span></ng-template>
          </td>
          <td>
            <ng-container *ngIf="change.deleted?.author; else noDeletion">
              <div class="author-cell">
                <p-avatar
                  [label]="change.deleted.author[0].toUpperCase()"
                  shape="circle"
                  [style]="{ 'background-color': getBgColor(change.deleted.author) }"
                  size="small"
                  styleClass="author-avatar"
                ></p-avatar>
                <div class="author-info" pTooltip="{{ change.deleted.author + '&#10;' + (change.deleted.timestamp | date: defaultDateTimeDisplayFormat) }}" tooltipPosition="top" [escape]="false">
                  <span class="author-name">{{ change.deleted.author }}</span>
                  <span class="author-date">{{ change.deleted.timestamp | date: defaultDateTimeDisplayFormat }}</span>
                </div>
              </div>
            </ng-container>
            <ng-template #noDeletion><span class="empty-cell"></span></ng-template>
          </td>
          <td>
            <ng-container *ngIf="change.renamed?.author; else noRename">
              <div class="author-cell">
                <p-avatar
                  [label]="change.renamed.author[0].toUpperCase()"
                  shape="circle"
                  [style]="{ 'background-color': getBgColor(change.renamed.author) }"
                  size="small"
                  styleClass="author-avatar"
                ></p-avatar>
                <div class="author-info" pTooltip="{{ change.renamed.author + '&#10;' + (change.renamed.timestamp | date: defaultDateTimeDisplayFormat) }}" tooltipPosition="top" [escape]="false">
                  <span class="author-name">{{ change.renamed.author }}</span>
                  <span class="author-date">{{ change.renamed.timestamp | date: defaultDateTimeDisplayFormat }}</span>
                </div>
              </div>
            </ng-container>
            <ng-template #noRename><span class="empty-cell"></span></ng-template>
          </td>
          <td>
            <a href="javascript:void(0)" class="highlight-link" (click)="openAllChangesDialog(change)">
              {{ 'VIEW_ALL_CHANGES_POPUP' | translate }}
            </a>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr class="no-records">
          <td [attr.colspan]="suiteMode ? 8 : 7" class="text-center">
            <div *ngIf="loading || initializing" class="loading-container">
              <p-progressSpinner></p-progressSpinner>
            </div>
            <span *ngIf="!loading && !initializing">{{ 'NO_COMPONENT_CHANGES_FOUND' | translate }}</span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<!-- All Changes Dialog Component -->
<app-all-changes-dialog
  [(visible)]="showAllChangesDialog"
  [component]="selectedComponent"
  [changes]="selectedComponentChanges"
  [loading]="dialogLoading"
  (dialogClose)="onAllChangesDialogClose()"
></app-all-changes-dialog>
